import { createAsyncThunk } from '@reduxjs/toolkit';
import { getMyWebinarTicketsAsync } from './WebinarTickets.request';

export const getMyWebinarTickets = createAsyncThunk(
  'getMyWebinarTickets',
  async () => {
    const { data } = await getMyWebinarTicketsAsync();

    return data;
  }
);
